import React from 'react'
import { useTranslation } from 'react-i18next'
import { SampleTable } from './SampleTable'

interface Props {
  type: string
  dataSource: [][]
}

export const SampleUpload = (props: Props): JSX.Element => {
  const { dataSource, type } = props
  const { t } = useTranslation(['onboarding'])
  const title = t('onboarding:confirmation.title')
  const remark = t('onboarding:confirmation.remark')
  const base = 'f-onboarding-confirmation'

  return (
    <div className={`${base}`}>
      <p className={`${base}__text-paragraph`}>{title}</p>
      <SampleTable type={type} dataSource={dataSource} />
      <p className={`${base}__text-remark`}>{remark}</p>
    </div>
  )
}
